<template>
  <div>
     <div class="header-card">
      <div class="close-btn">
        <img src="@/assets/close.png" height="18" width="18" alt="close-icon" @click="close()">
      </div>
      <div class="header-card-text">
        <h3>{{ investment.name }}</h3>
        <p class="sub-text secondary fnt-14">By: {{ investment.company }}</p>
        <span class="cabin-family bold sold-out" v-if="soldOut && !maturityStatus
        && investment.status === 'active'">
        Sold Out</span>
        <span class="cabin-family bold purchased"
        v-if="Object.keys(transaction).length && !invMatured(transaction.maturity_date)">
        Purchased</span>
        <!-- <span class="cabin-family bold sold-out" v-else-if="investment.status === 'inactive'">
        Expired</span> -->
        <span class="cabin-family bold purchased" v-if="invMatured(transaction.maturity_date)">
        Matured {{ paymentStatus }}</span>
      </div>
    </div>

    <div class="content">
      <div class="d-flex justify-content-between mb-4"
      v-if="!angelInvestment(transaction.maturity_date) && investment.duration > 0">
        <div class="text-left w-50">
          <p class="cabin-family secondary">Returns</p>
          <p class="black bold"><span class="primary">{{investment.percentage}}%</span> in
          {{ investment.duration }} months</p>
        </div>
        <div class="text-right w-50">
          <p class="cabin-family secondary">Price per Unit</p>
          <p class="cabin-family bold">
          <span v-if="investment.denomination == 'Naira'">₦</span>
          <span v-if="investment.denomination == 'Pound'">￡</span>
          <span v-if="investment.denomination == 'Dollar'">$</span>
          {{ Number(investment.amount).toLocaleString() || 0 }}</p>
        </div>
      </div>

      <div class="d-flex justify-content-between mb-4" v-if="Object.keys(transaction).length">
        <div class="text-left w-50">
          <p class="cabin-family secondary">Amount Invested</p>
          <p class="cabin-family bold">
          <span v-if="investment.denomination == 'Naira'">₦</span>
          <span v-if="investment.denomination == 'Pound'">￡</span>
          <span v-if="investment.denomination == 'Dollar'">$</span>
          {{ Number(transaction.amount).toLocaleString() }} </p>
        </div>
        <div class="text-right w-50" v-if="!angelInvestment(transaction.maturity_date)">
          <p class="cabin-family secondary">Expected Returns</p>
          <p class="cabin-family bold">
          <span v-if="investment.denomination == 'Naira'">₦</span>
          <span v-if="investment.denomination == 'Pound'">￡</span>
          <span v-if="investment.denomination == 'Dollar'">$</span>
          {{ Number(transaction.expected_returns).toLocaleString() }}
          </p>
        </div>
      </div>

      <div class="d-flex justify-content-between mb-4" v-if="Object.keys(transaction).length">
        <div class="text-left w-50"  v-if="!nullDateInvestment(transaction.start_date)">
          <p class="cabin-family secondary">Investment Date</p>
          <p class="cabin-family"> {{ transaction.start_date | formatDate2 }} </p>
        </div>
        <div class="text-right w-50" v-if="!angelInvestment(transaction.maturity_date)">
          <p class="cabin-family secondary">Maturity Date</p>
          <p class="cabin-family"> {{ transaction.maturity_date | formatDate2 }} </p>
        </div>
      </div>

      <div class="mb-5">
        <p class="cabin-family secondary">About Investment</p>
        <p class="cabin-family">{{ investment.description }}</p>
      </div>

      <div v-if="!soldOut && !Object.keys(transaction).length && investment.status === 'active'">
        <form @submit="agreementPop">
          <h4 class="text-center">Purchase Investment</h4>
          <div class="form-group">
            <label>How many Units?</label>
            <div class="form-control d-flex align-items-center">
              <input type="number" v-model="units" placeholder="" class="form-control unit"
               step=".1" @keyup="calculatePrice()" @change="calculatePrice()" required>
            <span>Units - <span>₦{{ Number(totalPrice).toLocaleString() || 0 }}</span>.00</span>
            </div>
          </div>

          <button class="btn primary-btn btn-block" :disabled="isDisabled">
              <span v-if="!loading"> Purchase Investment </span>
              <vue-loaders-ball-spin-fade-loader scale=".5" v-else>
              </vue-loaders-ball-spin-fade-loader>
          </button>
        </form>
      </div>
    </div>
    <success-component v-if="showSuccess" :message="successMsg" @close="closePrompt">
    </success-component>
    <error-component v-if="showError" :message="errorMsg" @close="closePrompt"></error-component>
    <investment-pop v-if="showInvPop" @accept="invest" @decline="declineAgreement"></investment-pop>
  </div>
</template>

<script>
import ErrorComponent from '../components/Error.vue';
import SuccessComponent from '../components/Success.vue';
import InvestmentPop from '../components/InvestmentPop.vue';
import { withWalletTypeData } from '../utils/walletType';

export default {
  components: {
    ErrorComponent,
    SuccessComponent,
    InvestmentPop,
  },
  props: ['id', 'trans'],
  computed: {
    isDisabled() {
      if (!this.units || (this.balance < this.totalPrice)
      || this.totalPrice < this.investment.amount || this.units === 0) {
        return true;
      }
      return false;
    },
    soldOut() {
      if (this.investment.units <= this.investment.sold_units) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      investment: {},
      transaction: {},
      units: 0,
      loading: false,
      totalPrice: 0,
      showError: false,
      showSuccess: false,
      showInvPop: false,
      errorMsg: '',
      successMsg: '',
      balance: 0,
      currentDate: '',
      maturityDate: '',
      paymentStatus: '',
      maturityStatus: false,
    };
  },
  mounted() {
    if (this.trans === 't') {
      this.getTransaction();
    } else {
      this.getInvestment();
    }
    this.balance = localStorage.getItem('balance');
  },
  methods: {
    async getInvestment() {
      const url = `${this.$baseUrl}/investment/${this.id}`;
      const res = await this.$http({ url, method: 'GET' });
      this.investment = res.data.investment;
    },
    angelInvestment(date) {
      if (date === '2099-01-01T00:00:00.000Z') {
        return true;
      }
      return false;
    },
    matured() {
      // if (this.currentDate >= this.maturityDate) {
      if (this.transaction.payment_status === 'paid') {
        this.paymentStatus = ' and Paid';
      } else if (this.transaction.payment_status === 'rescheduled') {
        this.paymentStatus = ' and Rescheduled';
      } else if (!this.transaction.payment_status) {
        this.paymentStatus = ' but not available for payment yet.';
      }
      this.maturityStatus = true;
    },
    nullDateInvestment(date) {
      if (date === '1970-01-01T00:00:00.000Z') {
        return true;
      }
      return false;
    },
    async getTransaction() {
      const url = `${this.$baseUrl}/transaction/${this.id}`;
      const res = await this.$http({ url, method: 'GET' });
      this.transaction = res.data.transaction;
      this.investment = this.transaction.investment;
      this.currentDate = new Date();
      this.maturityDate = new Date(this.transaction.maturity_date);
      this.matured();
    },
    async agreementPop(e) {
      e.preventDefault();
      this.showInvPop = true;
    },
    async declineAgreement() {
      this.showInvPop = false;
    },
    async invest() {
      this.showInvPop = false;
      if (this.units > 0 && this.totalPrice >= this.investment.amount) {
        this.loading = true;
        const data = withWalletTypeData(this.$store, {
          investmentId: this.id,
          amount: this.totalPrice,
          units: this.units,
        });
        try {
          const url = `${this.$baseUrl}/invest`;
          await this.$http({ url, data, method: 'POST' });
          this.successMsg = 'Investment Purchased Successfully';
          this.showSuccess = true;
          this.loading = false;
          setTimeout(() => {
            this.showSuccess = false;
            this.$router.push('/investments');
          }, 2500);
        } catch (error) {
          this.errorMsg = error.response.data.message;
          this.showError = true;
          this.loading = false;
          setTimeout(() => {
            this.showError = false;
          }, 2500);
        }
      }
    },
    calculatePrice() {
      if (this.units >= 0) {
        this.totalPrice = this.units * Number(this.investment.amount) || 0;
      }
      if (this.balance < this.totalPrice) {
        this.$toast.error('Insufficient funds to purchase Investment', {
          position: 'top-right',
          duration: 2500,
          type: 'error',
          dismissible: true,
        });
      }
    },
    close() {
      this.$router.go(-1);
    },
    closePrompt() {
      this.showError = false;
      this.showSuccess = false;
    },
    invMatured(matDate) {
      const currentDate = new Date();
      const maturityDate = new Date(matDate);
      if (currentDate >= maturityDate) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.sold-out{
  width: 75px;
  margin: 0;
}
.header-card-text{
  margin-bottom: 0;
}
</style>
